import { render, staticRenderFns } from "./BookingDurationSettings.vue?vue&type=template&id=341786eb&"
import script from "./BookingDurationSettings.vue?vue&type=script&lang=ts&"
export * from "./BookingDurationSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports